// COMPONENTS
import { BaseText } from "../../../../../components";

// UTILS
import { formatCurrency } from "../../../../../utils";
import getPlaceholderImage from "../helpers/getPlaceholderImage";

// TYPES
import { OrderSingleItemProps } from "../types";

const StandaloneItem: React.FC<OrderSingleItemProps> = ({
	item,
	fields,
	hostName,
	currencyCharacter,
}) => {
	///// TEXT FROM FIELDS /////
	const quantityLabel = fields?.orderItems?.itemDetails?.quantity?.prefix;
	const partNumberLabel = fields?.orderItems?.itemDetails?.partNumber?.prefix;
	const currencyLabel = currencyCharacter;

	///// DATA INTO VARS /////
	const itemTitle = item?.item?.title || item?.item?.description || "-";
	const itemPartNumber = item?.item?.partNumber;

	const itemPrice =
		item.price !== null && item.price !== undefined
			? formatCurrency(item.price, 2)
			: "-";

	const itemQuantity = parseInt(item.quantity, 10);
	const itemImageSource =
		item?.item?.itemImages?.length > 0
			? item?.item?.itemImages[0]?.thumbnailImage?.sourceUrl
			: null;

	const itemImage = itemImageSource ? (
		<img
			src={itemImageSource || getPlaceholderImage(hostName)}
			alt="Item"
			className="w-full h-full object-cover"
		/>
	) : (
		<div className="">
			<img
				src={getPlaceholderImage(hostName)}
				alt="Item"
				className="w-full h-full object-cover"
			/>
		</div>
	);

	///// CLASS NAMES /////
	const bundleItemImageContainerClasses = `mr-6 p-3 rounded-lg flex items-center justify-center h-full w-16 max-sm:w-3 max-sm:p-1`;

	return (
		<div className="flex py-3 px-2" data-testid="approval-standalone-item">
			<div className={bundleItemImageContainerClasses}>{itemImage}</div>
			<div className="flex flex-col text-left">
				<BaseText
					text={itemTitle}
					size="sm:text-lg text-sm"
					color="text-navy-500"
					fontFamily="font-inter-semibold"
					tag="h3"
					dataTestId="approval-item-title"
				/>

				<div className="flex gap-x-5 max-sm:flex-col">
					<BaseText
						text={`${partNumberLabel} ${itemPartNumber}`}
						size="sm:text-base text-sm"
						color="text-primary-text"
						fontFamily="font-inter-regular"
						tag="p"
						dataTestId="approval-item-part-number"
					/>
				</div>
				<div className="flex flex-row gap-2">
					<BaseText
						text={`${currencyLabel} ${itemPrice}`}
						size="sm:text-base text-sm"
						color="text-navy-500"
						tag="p"
						fontFamily="font-inter-regular"
					/>
					<BaseText
						text={`${quantityLabel} ${itemQuantity}`}
						size="sm:text-base text-sm"
						color="text-navy-500"
						tag="p"
						fontFamily="font-inter-regular"
					/>
				</div>
			</div>
		</div>
	);
};

export default StandaloneItem;
